import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ 
  title, 
  description, 
  icon, 
  buttonText, 
  onClick, 
  variant = "default",
  className = "" 
}) => {
  const getVariantStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-primary text-primary-foreground border-primary';
      case 'accent':
        return 'bg-accent text-accent-foreground border-accent';
      case 'success':
        return 'bg-success text-success-foreground border-success';
      default:
        return 'bg-card text-card-foreground border-border hover:bg-muted/50';
    }
  };

  return (
    <div className={`
      border rounded-lg p-6 transition-all duration-200 cursor-pointer
      ${getVariantStyles()}
      ${className}
    `} onClick={onClick}>
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 rounded-lg bg-background/20 flex items-center justify-center">
            <Icon name={icon} size={24} color="currentColor" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          <p className="text-sm opacity-80 mb-4">{description}</p>
          <Button
            variant={variant === 'default' ? 'default' : 'outline'}
            size="sm"
            onClick={(e) => {
              e?.stopPropagation();
              onClick();
            }}
            className="w-full sm:w-auto"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionCard;